export enum FieldMaskTypeEnum {
  InputMask = "InputMask",
  TextFieldForm = "TextField",
}
